import React from 'react';
import { createPortal } from 'react-dom';
import Overlay from '../../atoms/Overlay';
import ModalContent from './ModalContent';
/*
 * This component is based on @reach/dialog.
 * https://github.com/reach/reach-ui/blob/main/packages/dialog/src/index.tsx
 * https://reach.tech/dialog
 */
const Modal = ({ isOpen, children, onDismiss, testId = 'store-modal', ...otherProps }) => {
    const handleBackdropClick = (event) => {
        if (event.defaultPrevented) {
            return;
        }
        event.stopPropagation();
        onDismiss?.(event);
    };
    const handleBackdropKeyDown = (event) => {
        if (event.key !== 'Escape' || event.defaultPrevented) {
            return;
        }
        event.stopPropagation();
        onDismiss?.(event);
    };
    return isOpen
        ? createPortal(React.createElement(Overlay, { "data-modal-overlay": true, onClick: handleBackdropClick, onKeyDown: handleBackdropKeyDown },
            React.createElement(ModalContent, Object.assign({}, otherProps, { testId: testId }), children)), document.body)
        : null;
};
export default Modal;
//# sourceMappingURL=Modal.js.map